module.exports = __webpack_public_path__ + "img/IMG_1627_WoodMatted_MockedUp.ece02e93.jpg";